export default __webpack_public_path__ + "static/media/imgVideoPrison.a5307594.png";